import { useTheme } from 'styled-components';

export const WarningIndicatorIcon: React.FC<{ className?: string }> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4971 10.7081L8.82289 0.88306L8.82055 0.884232C8.74907 0.739506 8.65767 0.604152 8.53755 0.484032C7.96509 -0.0884275 7.03635 -0.0884275 6.46395 0.484032C6.36023 0.587744 6.27469 0.704352 6.21024 0.826812V0.82564L0.538886 10.653V10.6554C0.449238 10.7866 0.378342 10.9349 0.335562 11.0983C0.125802 11.8812 0.589856 12.6862 1.37209 12.8949C1.51272 12.933 1.6551 12.9482 1.79572 12.9435L13.1425 12.9418V12.94C13.6856 12.9781 14.2282 12.7138 14.52 12.2117C14.7977 11.7277 14.772 11.1511 14.4972 10.7082L14.4971 10.7081ZM7.50454 11.6086C6.819 11.6086 6.26295 11.0532 6.26295 10.367C6.26295 9.6815 6.81841 9.12545 7.50454 9.12545C8.19009 9.12545 8.74614 9.6815 8.74614 10.367C8.74673 11.0532 8.19067 11.6086 7.50454 11.6086V11.6086ZM7.944 8.32679H7.03813L6.20025 4.70279C6.20025 3.98443 6.78208 3.40259 7.50045 3.40259C8.21823 3.40259 8.80065 3.98501 8.80065 4.70338L7.944 8.32679Z"
        fill={theme.extraColors.orangeWarning}
      />
    </svg>
  );
};
